<div *ngIf="!pane || !pane.users else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>

<ng-template #contentBlock>
  <div class="content">
    <div class="content-cards">
      <div *ngFor="let teacher of users; let i = index; trackBy: trackByFn" class="card-wrap">
        <app-teacher-card [teacher]="teacher" (favoriteChanged)="onFavoriteChanged(i)"></app-teacher-card>
      </div>
    </div>

    <loading-line *ngIf="pane.loading" height="40px" width="100%"></loading-line>
    <span inViewport (inViewportAction)="onInViewportBottomChange($event)"></span>

    <ng-container *ngIf="!users.length && !pane.loading" [ngTemplateOutlet]="noContentStub"></ng-container>
  </div>
</ng-template>

<ng-template #noContentStub>
  <app-empty [empty]="emptyObj"></app-empty>
</ng-template>
